import { Modal } from "react-bootstrap";
import React from "react";
import ButtonComponent from "./ButtonComponent";

const AlertComponent = ({ id, show, close, action }) => {
  return (
    <Modal show={show} centered="true">
      <Modal.Body className="modal-body" style={{ color: "white" }}>
        <h5> APAKAH ANDA YAKIN INGIN MENGHAPUS? </h5>
      </Modal.Body>
      <Modal.Footer className="modal-footer" style={{ borderTop: "none" }}>
        <ButtonComponent
          color="white"
          backgroundColor="#3003fc"
          backgroundHover="#2404b5"
          onClick={action}
        >
          <i className="fas fa-trash" size="sm" />
          &nbsp; Hapus
        </ButtonComponent>
        <ButtonComponent
          color="white"
          backgroundColor="#fc030f"
          backgroundHover="#b50407"
          onClick={close}
        >
          <i className="fa fa-ban me-1" size="sm" />
          &nbsp;Batal
        </ButtonComponent>
      </Modal.Footer>
    </Modal>
  );
};

export default AlertComponent;
